<template>
    <v-dialog v-model="openDialog"  persistent max-width="880px">
      <div class="dialog-body tw-container tw-mx-auto">
        <header>
            <div class="flex">
                <img style="width: 150px" :src=" renderChannelType(doc['@ChannelType']) " alt=""> 
            </div>
            <div class="flex float-right" style="line-height: 38px;">
                <h3>
                    หมายเลขคำสั่งซื้อ: 
                </h3>
                <h3 class="text-orange" style="margin-left: 5px;">
                    {{doc['orderID']}}
                </h3>
                <i @click="closeDialogFunc" class="v-icon notranslate mdi mdi-close-circle-outline theme--light" style="font-size: 36px; margin: -10px; margin-left: 20px; color: #181818; cursor: pointer;"></i>
            </div>
        </header>
        <body>
            <div>
                <div class="tw-50 flex">
                    <p>
                        <b>ที่อยู่ในการจัดส่ง</b>
                    </p>
                    <p>{{addressBillingName(doc['addressBilling'])}}</p>
                    <p>{{addressBillingAddress(doc['addressBilling'])}}</p>
                </div>
                <div class="tw-50 flex">
                    <p>
                        <b>
                            ข้อมูลการขนส่ง
                        </b>
                    </p>
                    <p>
                        {{doc['shippingCarrierType']}} - {{doc['shippingCarrierName']}}
                    </p>
                </div>
            </div>
            <div class="b-t-orange"></div>
            <div>
                <div class="tw-50 flex">
                    <p>
                        <b>
                            รายละเอียดการชำระเงิน
                        </b>
                    </p>
                </div>
                <div class="tw-20 flex" style="text-align: right;">
                    <p>
                        <b>
                            ราคา / ชิ้น
                        </b>
                    </p>
                </div>
                <div class="tw-10 flex" style="text-align: right;">
                    <p>
                        <b>
                            จำนวน
                        </b>
                    </p>
                </div>
                <div class="tw-20 flex" style="text-align: right;">
                    <p>
                        <b>
                            ราคาขายสุทธิ
                        </b>
                    </p>
                </div>
            </div>
            <div v-for="order in doc['orderItems']" :key="order.orderItemID">
                <div class="tw-50 flex nowrap" style="align-items: center;">
                    <div class="tw-30" v-if="order.productImage1" style="margin-right: 40px;">
                        <img :src="order.productImage1" alt=""> 
                    </div>
                    <div class="">
                        <p>
                            {{order.orderItemName}}
                        </p>
                        <p>
                            ตัวเลือกสินค้า: {{order.variationName}}
                        </p>
                        <p>
                            เลข SKU: {{order.sellerSKU}}
                        </p>
                    </div>
                </div>
                <div class="tw-20 flex" style="vertical-align: top; text-align: right;">
                    <p>
                        {{formatCurrency(order.variationAmountOriginal)}}
                    </p>
                </div>
                <div class="tw-10 flex" style="vertical-align: top; text-align: right;">
                    <p>
                        {{order.variationQuantityPurchased}}
                    </p>
                </div>
                <div class="tw-20 flex" style="vertical-align: top; text-align: right;">
                    <p>
                        {{formatCurrency(order.variationAmountOriginal * order.variationQuantityPurchased)}}
                    </p>
                </div>
            </div>
            <div class="b-t-gray"></div>
            <div>
                <div class="tw-50 flex">

                </div>
                <div class="tw-50 flex tw-text-right">
                    <div class="tw-25 flex">
                        <p>รวมค่าสินค้า</p>
                        <p>ค่าจัดส่งทั้งหมด</p>
                        <!-- <p><b>ยอดชำระเงิน</b></p> -->
                        <p>ส่วนลด</p>
                        <p><b>ยอดรวม</b></p>
                    </div>
                    <div class="tw-25 flex">
                        <p>฿{{formatCurrency(doc.orderAmountTotal)}}</p>
                        <p>฿{{formatCurrency(doc.shippingFeeAmount || doc.shippingFeeAmountEstimate)}}</p>
                        <!-- <p>฿{{formatCurrency(Math.abs(doc.orderAmountTotal - (orderAmountTotal(doc.orderItems)) - (doc.shippingFeeAmount || doc.shippingFeeAmountEstimate)))}}</p> -->
                        <p>฿{{formatCurrency(doc.voucherAmount)}}</p>
                        <p class="text-orange"><b>฿{{formatCurrency(Math.abs(doc.orderAmountTotal-doc.voucherAmount+(doc.shippingFeeAmount || doc.shippingFeeAmountEstimate)))}}</b></p>
                    </div>
                </div>
            </div>
            <!-- <div class="b-t-gray"></div>
            <div>
                <div>
                    <p><b>การชำระเงินของผู้ซื้อ</b></p>
                </div>
                <div class="tw-50 flex">
                </div>
                <div class="tw-50 flex tw-text-right">
                    <div class="tw-25 flex">
                        <p>รวมค่าสินค้า</p>
                        <p>ค่าจัดส่งทั้งหมด</p>
                        <p><b>การชำระทั้งหมดของผู้ซื้อ</b></p>
                    </div>
                    <div class="tw-25 flex">
                        <p>฿380</p>
                        <p>฿29</p>
                        <p><b>409</b></p>
                    </div>
                </div>
            </div> -->
        </body>
      </div>
    </v-dialog>
</template>

<script>
export default {
    name: 'SaleordersReport',
    props: ['openDialog', 'doc', 'close-dialog'],
    data() {
        return {
            channelType: {
                "1": "https://lh3.googleusercontent.com/2TVq2jtQo6503S7JQG_gUIyf_S-FB7fyyrkGsdZoARtZy36WJCf52MDPBmbL_sFhRBFkDMeeeszr__VNqtCG8MZK1AwxUVzE=w" + Math.round(150 * window.devicePixelRatio),
                "2": "https://lh3.googleusercontent.com/Bmjz8d9zSiyefrvbxf_DW0yaeEOpE-PCXs5rTyMSic-173eEeO8e8Wy2rNyme-XpbKiD-sTcy4LvPXJZR9tAv9YeQYYZD5tPQQ=w" + Math.round(150 * window.devicePixelRatio),
                "3": "/images/logo/TikTok-logo-CMYK-Horizontal-black.png?w=" + Math.round(150 * window.devicePixelRatio)
            },
        }
    },
    methods: {
        closeDialogFunc() {
            this.$emit('close-dialog');
        },
        addressBillingName(address) {
            if(!address) return ''
            return `${address.name}, ${address.phone1}`
        },
        addressBillingAddress(address) {
            if(!address) return ''
            return `${address.line1}`
        },
        orderAmountTotal(orders) {
            if(!orders) return 0
            let total = 0
            for(let e of orders) {
                total += e.variationAmountDiscounted // * e.variationQuantityPurchased
            }
            return total
        },
        renderChannelType(type) {
            if(!type) return ''
            return this.channelType[type]
        },
        formatCurrency(amount) {
            if(amount === null || amount === undefined) return '0.00'
            return new Intl.NumberFormat('th-TH', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(amount / 100)
        },
    }
}
</script>

<style lang="scss" scoped>
    .dialog-body {
        line-height: 1.3em;
    }
    .right {
        float: right;
    }
    h3 {
        display: inline-block;
        font-weight: 700;
    }
    p {
        display: block;
    }
    .flex {
        display: inline-flex;
        flex-wrap: wrap;
        padding: 15px;
        p {
            flex: 1 0 100%;
        }
    }
    header {
        padding: 20px 40px;
        background-color: #F2F2F2;
    }
    body {
        padding: 20px 40px; 
        background-color: #FFFFFF;
    }
    .tw-50 {
        width: 50%;
    }
    .tw-30 {
        width: 30%;
    }
    .tw-20 {
        width: 20%;
    }
    .tw-25 {
        width: 25%;
    }
    .tw-10 {
        width: 10%;
    }
    .tw-80 {
        width: 80%;
    }
    .b-t-orange{
        border-top: solid #F1582C 1px;
        margin: 20px -15px;
    }
    .b-t-gray{
        border-top: solid #C4C4C4 1px;
        margin: 20px -15px;
    }
    .text-orange{
        color: #F1582C;
    }
    .nowrap {
        flex-wrap: nowrap;
    }
</style>
